export default "__VITE_ASSET__BabE7ejo__"